<template>
  <div class="edit_page">
    <div class="edit_wrapper"></div>
    <div class="edit">
      <div class="edit_top">
        <div class="edit_top_buttons">
          <input
            type="button"
            :value="cancelButton"
            class="cancel_button"
            @click="cancel"
          />
          <input
            type="button"
            :value="finishButton"
            class="finish_button"
            @click="update"
          />
        </div>
      </div>
      <div class="detail">
        <div class="detail_contents">
          <div class="assign_name detail_content">
            <div class="assign_name_label detail_label">
              {{ nameLabel }}
              <div class="require_items_label">
                {{ requiredItemLabel }}
              </div>
            </div>
            <input
              class="detail_input_field"
              type="text"
              v-model="assign.name"
              @input="inputUpdate('name')"
            />
          </div>
          <div class="type detail_content">
            <div class="type_label detail_label">
              {{ typeLabel }}
              <div class="require_items_label">
                {{ requiredItemLabel }}
              </div>
            </div>
            <select class="drop_down_list" v-model="selectedTypeId" :style="selectedStyle" @change="inputUpdate('type')">
              <option disabled selected value="" style="background-color: lightgray; color: white;">{{
                selectedColorName.name
              }}</option>
              <option v-for="type in typeList" :value="type.id" :key="type.id" :style="{ backgroundColor: type.background, color: type.text}">
                {{ type.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="edit_bottom">
        <input
          type="button"
          :value="deleteButton"
          class="edit_delete_button"
          @click="showModal = true"
        />
      </div>
      <div class="modalWindow" v-if="showModal">
        <modalWindow
          :question="deleteWord"
          :router="router"
          @close="stayClose"
          @remove="remove"
        >
        </modalWindow>
      </div>
      <div class="complete_modal_window" v-if="showCompleteModal">
        <completeModalWindow :question="completeWord" @close="close">
        </completeModalWindow>
      </div>
      <div class="complete_modal_window" v-if="showFailureModal">
        <completeModalWindow :question="failureWord" @close="stayClose">
        </completeModalWindow>
      </div>
      <div class="loading_modal_window" v-if="showloadingModal">
        <loadingModalWindow @close="close"> </loadingModalWindow>
      </div>
    </div>
  </div>
</template>

<script>
import modalWindow from '../modalWindow/detailDeleteModalWindow.vue'
import completeModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'

export default {
  data() {
    return {
      cancelButton: 'キャンセル',
      finishButton: '完了',
      deleteButton: 'この情報を削除',
      nameLabel: '役割',
      typeLabel: '色',
      router: '/assigns',
      deleteWord: 'この情報を削除してよろしいですか？',
      completeWord: '',
      failureWord: '',
      showModal: false,
      showCompleteModal: false,
      showloadingModal: false,
      showFailureModal: false,
      selectedTypeId: ''
    }
  },
  computed: {
    assign() {
      return this.$store.state.assigns.assign
    },
    typeList() {
      return this.$store.state.assigns.typeList
    },
    indexOfTypeList() {
      for (let i = 0; i < this.$store.state.assigns.typeList.length; i++) {
        if (this.$store.state.assigns.typeList[i].id === this.assign.type) {
          return i
        }
      }
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    requiredItemLabel() {
      return this.$store.state.error.requiredItemLabel
    },
    selectedType() {
      return this.typeList.find(type => type.id === this.selectedTypeId)
    },
    selectedStyle() {
      return this.selectedType
        ? {
            backgroundColor: this.selectedType.background,
            color: this.selectedType.text
          }
        : {
            backgroundColor: this.typeList[this.indexOfTypeList].background,
            color: this.typeList[this.indexOfTypeList].text
          }
    },
    selectedColorName() {
      return this.selectedType
        ? {
            name: this.selectedType.name
          }
        : {
            name: this.typeList[this.indexOfTypeList].name
          }
    }
  },
  components: {
    modalWindow,
    completeModalWindow,
    loadingModalWindow
  },
  methods: {
    inputUpdate(e) {
      this.$store.dispatch('assigns/inputUpdate', {
        name: e,
        value: event.target.value
      })
    },
    async cancel(e) {
      this.showloadingModal = true
      try {
        await this.$store.dispatch(
          'assigns/setDetailAssign',
          this.$store.state.assigns.assign
        )
        this.$router.push('../assigns/detail')
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_660001
        let eventType = 3
        let reason = 'MSGCRC0223'
        if (error.response) {
          this.failureWord =
            this.errorMsg.MSGCRC0223.name +
            this.errorMsg.MSGCRC0223.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    async update(e) {
      this.showloadingModal = true
      try {
        await this.$store.dispatch('assigns/updateAssign')
        this.$emit('list-reload')
        if (location.pathname !== '/assigns/detail') {
          this.$router.push('../assigns/detail')
        }
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_660001
        let eventType = 3
        let reason = ''
        if (
          error.response &&
          error.response.data &&
          error.response.data.header &&
          error.response.data.header.message
        ) { 
          let errorMessage = error.response.data.header.message
          if (errorMessage === 'MSGCRC0207') {
            this.failureWord =
              this.errorMsg.MSGCRC0207.name +
              this.errorMsg.MSGCRC0207.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0208') {
            this.failureWord =
              this.errorMsg.MSGCRC0208.name +
              this.errorMsg.MSGCRC0208.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else {
            this.failureWord =
              this.errorMsg.MSGCRC0224.name +
              this.errorMsg.MSGCRC0224.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          }
          reason = errorMessage + ' '
          reason += error.response.status
         } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
         }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFailureModal = true
        this.showloadingModal = false
        return
      }
      try {
        await this.$store.dispatch(
          'assigns/setDetailAssign',
          this.$store.state.assigns.assign
        )
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_660001
        let eventType = 3
        let reason = 'MSGCRC0223'
        if (error.response) {
          this.failureWord =
            this.errorMsg.MSGCRC0223.name +
            this.errorMsg.MSGCRC0223.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    close(e) {
      this.showModal = false
      this.showCompleteModal = false
      this.$router.push(this.router)
    },
    stayClose(e) {
      this.showModal = false
      this.showCompleteModal = false
      this.showFailureModal = false
    },
    async remove(e) {
      this.showloadingModal = true
      let assignId = this.$store.state.assigns.assign.id
      try {
        await this.$store.dispatch('assigns/deleteAssigns', [assignId])
        this.$emit('list-reload')
        this.showModal = false
        this.completeWord = '削除しました。'
        this.showCompleteModal = true
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_660001
        let eventType = 3
        let reason = 'MSGCRC0225'
        if (error.response) {
          this.failureWord =
            this.errorMsg.MSGCRC0225.name +
            this.errorMsg.MSGCRC0225.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
         } else {
            reason = 'MSGCRC0005'
            eventType = 9
            this.failureWord =
              this.errorMsg.MSGCRC0005.name +
              this.errorMsg.MSGCRC0005.value +
              'エラーコード：{' +
              eventNumber +
              '}'
         }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showModal = false
        this.showFailureModal = true
      }
      this.showloadingModal = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/assigns/assignEdit.vue